angular.module('bmsApp.merrymaids.houseTemplate').controller('MMHouseTemplateViewCtrl', [
    '$scope', '$state', 'MMHouseTemplateSvc', function (
        $scope
        , $state
        , MMHouseTemplateSvc) {

        function init() {
            var id = $state.params.houseTemplateId;
            MMHouseTemplateSvc.read({ id: id }).then(function(response){
                self.houseTemplate = response.data.mm_house_template;
            });
        }

        function deleteTemplate() {
            MMHouseTemplateSvc.delete({ id: self.houseTemplate.id }).then(function(response){
                $state.go('main.merrymaids.houseTemplate.index');
            });
        }

        var self = $scope.MMHouseTemplateViewCtrl = {

            methods: {
                init: init,
                deleteTemplate: deleteTemplate
            },

            houseTemplate: {}

        };

    }]);
